import * as React from 'react'
import { FC, useMemo } from 'react'

import { ISalesFunnelSummaryReason } from '@user/store/salesFunnelSummary/typings'
import { ToTitleCase } from '@user/utils/ToTitleCase'

import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

const styles = {
  value: {
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '16px',
  },

  title: {
    fontFamily: 'Source Sans Pro Semibold',
  },
}

interface Props {
  reasons: ISalesFunnelSummaryReason[]
  status: 'disqualified' | 'lost'
}

export const ReasonsPopoverContent: FC<Props> = (props) => {
  const { reasons, status } = props

  const title: string = useMemo(() => {
    return `Top ${reasons.length > 1 ? reasons.length : ''} ${ToTitleCase(
      status,
    )} ${reasons.length == 1 ? 'Reason' : 'Reasons'}`
  }, [reasons.length, status])

  return (
    <Box mt={1.5}>
      <Grid item>
        <Box mb={1}>
          <Typography sx={styles.title}>{title}</Typography>
        </Box>
      </Grid>
      <Grid item container>
        {reasons.length == 0 ? (
          <Alert severity="info" style={{ width: '100%' }}>
            There are no {status} reasons to display.
          </Alert>
        ) : (
          <>
            {reasons.map((r, i) => (
              <Grid item container key={i}>
                <Box display="flex" alignItems="center" flexGrow={1}>
                  <Typography>{r.name}</Typography>
                </Box>
                <Box display="flex" alignItems="center">
                  <Typography sx={styles.value}>{r.count}</Typography>
                </Box>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </Box>
  )
}

ReasonsPopoverContent.displayName = 'ReasonsPopoverContent'
